import { createGetAsyncSlice } from '@sonar-software/xuder';
import { getDataSecurityAccessAuditById } from '@api/data-security';

export const getCoreDataSecurityAccessAuditByIdSlice = createGetAsyncSlice({
	name: 'CoreDataSecurityAccessAuditById',
	receive: true,
	request: true,
	requestHandler: getDataSecurityAccessAuditById,
	retainDataOnRequest: true
});
